






















import { defineComponent, computed } from '@vue/composition-api'

import { INotice } from '@/types/notice'

type Props = {
  notices: INotice[]
  total: number
  loading: boolean
}

export default defineComponent({
  name: 'NoticesTable',
  props: {
    notices: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props: Props, context) {
    const store = context.root.$store

    const headers = [
      { text: 'ID', value: 'id' },
      { text: 'タイトル', value: 'title' },
      { text: '本文', value: 'content' },
      { text: '配信対象', value: 'distributeFor' },
      { text: '作成ユーザID', value: 'createdById' },
      { text: '有効', value: 'isValid' },
    ]
    const items = computed(() => {
      return props.notices
    })

    const onClickEditButton = async (
      item: Record<string, string | boolean>,
    ) => {
      await store.dispatch('notice/getNotice', item)
      context.root.$router.push('/notice-edit').catch(() => {
        /*2連打した際のerrorを無視*/
      })
    }

    const options = {}

    return { headers, items, onClickEditButton, options }
  },
})
